import { TrackingApi, useAPIAction } from "melco-shared-logic";

export const useDownloadAllUsersReport = (
  productCode: string,
  dateRange: any
) => {
  return useAPIAction(
    TrackingApi,
    async (api) => {
      const data = await api.analyticExportAllDownloadSummary({
        productCode: productCode,
        startTimestamp: dateRange.start,
        endTimestamp: dateRange.end,
        format: "csv",
      });

      console.log(data);
      return {
        successMessages: [],
        data,
      };
    },
    {
      translationPrefix: "global",
    }
  );
};
